import fetcher from 'api/fetcher';
import { getIndexByEntityId } from 'utils/clickme';

import urlParser from 'bloko/common/urlParser';

import { Banner, setBanners, setBannerSaving } from 'store/models/dashboard';
import { AppThunkAction } from 'store/utils';

export const updateBannerStatus = (
    campaignId: number,
    bannerId: number,
    enabled: boolean
): AppThunkAction<Promise<void> | null> => {
    return (dispatch, getState) => {
        const state = getState();
        const { campaigns } = state.dashboard;
        const campaignIdx = getIndexByEntityId(campaignId, campaigns, 'id');
        if (campaignIdx === -1) {
            return null;
        }
        const queryStr = urlParser.stringify({
            bannerId,
            enabled: String(!enabled),
        });

        dispatch(setBannerSaving(true));

        return fetcher
            .put(`/api/v1/banners/${bannerId}/status?${queryStr}`)
            .then(() => {
                const campaign = campaigns[campaignIdx];
                const newCampaigns = [...campaigns];

                const allBanners: Banner[] = campaign.allBanners.map((banner) => {
                    return banner.id === bannerId ? { ...banner, enabled: !enabled } : banner;
                });

                newCampaigns[campaignIdx] = {
                    ...campaign,
                    allBanners,
                };

                dispatch(setBanners(newCampaigns));
            })
            .finally(() => {
                dispatch(setBannerSaving(false));
            });
    };
};
